import { render, staticRenderFns } from "./MicrosoftOAth.vue?vue&type=template&id=53cefe52&scoped=true&"
import script from "./MicrosoftOAth.vue?vue&type=script&lang=js&"
export * from "./MicrosoftOAth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cefe52",
  null
  
)

export default component.exports